import React, { Component } from 'react';
import TouchButton from '../components/TouchButton';

const Navbar = React.createClass({
    render() {
        return (
            <nav className="navbar navbar-default">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <TouchButton type="button" className="navbar-toggle collapsed" data-toggle="collapse"
                                data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </TouchButton>
                        <a className="navbar-brand" href="#"><img src="/static/img/albert-brand.png"/> </a>
                    </div>

                    <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">

                        <form className="navbar-form navbar-left" role="search">
                            <span className="glyphicon glyphicon-search"></span>
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Search exercises and topics"/>
                            </div>
                            <TouchButton type="submit" className="btn btn-default">Go</TouchButton>
                        </form>
                        <ul className="nav navbar-nav navbar-right">
                            <li><a href="#"><span className="glyphicon glyphicon-headphones"></span></a></li>
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }
});

export default Navbar


/** WEBPACK FOOTER **
 ** ./src/mocks/Navbar.js
 **/